import  { useState, useEffect } from 'react'
import { Modal, Carousel } from "react-bootstrap";
import "bootstrap-icons/font/bootstrap-icons.css";
import { TesCarousel } from '../../components/TesCarousel';
import { useInView } from 'react-intersection-observer';
import emailjs from '@emailjs/browser';
import { useNavigate } from "react-router-dom";
import { Helmet } from 'react-helmet-async';

export const FourDaysTanzaniasafaris = () => {
     const images = [
                "https://redlionandcompany.com/Assets/kamarezOfArica/Package%201/415px%20276px/Plan%20de%20travail%202.png",
                "https://redlionandcompany.com/Assets/kamarezOfArica/Package%201/415px%20276px/Plan%20de%20travail%203.png",
                "https://redlionandcompany.com/Assets/kamarezOfArica/Package%201/415px%20276px/Plan%20de%20travail%204.png",
                "https://redlionandcompany.com/Assets/kamarezOfArica/Package%201/415px%20276px/Plan%20de%20travail%205.png",
                "https://redlionandcompany.com/Assets/kamarezOfArica/Package%201/415px%20276px/Plan%20de%20travail%201.png"
            ];
            const [showModal, setShowModal] = useState(false);
            const [activeIndex, setActiveIndex] = useState(0);
            const [itemsPerSlide, setItemsPerSlide] = useState(2);
        
            // Update items per slide based on window width
            useEffect(() => {
                const handleResize = () => {
                    setItemsPerSlide(window.innerWidth < 768 ? 1 : 2);
                };
                handleResize(); // initial
                window.addEventListener("resize", handleResize);
                return () => window.removeEventListener("resize", handleResize);
            }, []);
        
            // Group images into slides
            const slides = [];
            for (let i = 0; i < images.length; i += itemsPerSlide) {
                slides.push(images.slice(i, i + itemsPerSlide));
            }
        
            const handleShow = (index) => {
                setActiveIndex(index);
                setShowModal(true);
            };
        
            const backgroundUrl = "https://africantraveltour.com/assets/img/4-days-tanzania-safari-banner.jpg";
        
            const { ref: cardsRef, inView: isInView } = useInView({
                threshold: 0.1,
            });
            {/* form Data */ }
            const countryCodes = [
                { name: "Afghanistan", dial_code: "+93", code: "AF" },
                { name: "Albania", dial_code: "+355", code: "AL" },
                { name: "Algeria", dial_code: "+213", code: "DZ" },
                { name: "Andorra", dial_code: "+376", code: "AD" },
                { name: "Angola", dial_code: "+244", code: "AO" },
                { name: "Antigua and Barbuda", dial_code: "+1-268", code: "AG" },
                { name: "Argentina", dial_code: "+54", code: "AR" },
                { name: "Armenia", dial_code: "+374", code: "AM" },
                { name: "Australia", dial_code: "+61", code: "AU" },
                { name: "Austria", dial_code: "+43", code: "AT" },
                { name: "Azerbaijan", dial_code: "+994", code: "AZ" },
                { name: "Bahamas", dial_code: "+1-242", code: "BS" },
                { name: "Bahrain", dial_code: "+973", code: "BH" },
                { name: "Bangladesh", dial_code: "+880", code: "BD" },
                { name: "Barbados", dial_code: "+1-246", code: "BB" },
                { name: "Belarus", dial_code: "+375", code: "BY" },
                { name: "Belgium", dial_code: "+32", code: "BE" },
                { name: "Belize", dial_code: "+501", code: "BZ" },
                { name: "Benin", dial_code: "+229", code: "BJ" },
                { name: "Bhutan", dial_code: "+975", code: "BT" },
                { name: "Bolivia", dial_code: "+591", code: "BO" },
                { name: "Bosnia and Herzegovina", dial_code: "+387", code: "BA" },
                { name: "Botswana", dial_code: "+267", code: "BW" },
                { name: "Brazil", dial_code: "+55", code: "BR" },
                { name: "Brunei", dial_code: "+673", code: "BN" },
                { name: "Bulgaria", dial_code: "+359", code: "BG" },
                { name: "Burkina Faso", dial_code: "+226", code: "BF" },
                { name: "Burundi", dial_code: "+257", code: "BI" },
                { name: "Cambodia", dial_code: "+855", code: "KH" },
                { name: "Cameroon", dial_code: "+237", code: "CM" },
                { name: "Canada", dial_code: "+1", code: "CA" },
                { name: "Cape Verde", dial_code: "+238", code: "CV" },
                { name: "Central African Republic", dial_code: "+236", code: "CF" },
                { name: "Chad", dial_code: "+235", code: "TD" },
                { name: "Chile", dial_code: "+56", code: "CL" },
                { name: "China", dial_code: "+86", code: "CN" },
                { name: "Colombia", dial_code: "+57", code: "CO" },
                { name: "Comoros", dial_code: "+269", code: "KM" },
                { name: "Congo (DRC)", dial_code: "+243", code: "CD" },
                { name: "Congo (Republic)", dial_code: "+242", code: "CG" },
                { name: "Costa Rica", dial_code: "+506", code: "CR" },
                { name: "Croatia", dial_code: "+385", code: "HR" },
                { name: "Cuba", dial_code: "+53", code: "CU" },
                { name: "Cyprus", dial_code: "+357", code: "CY" },
                { name: "Czech Republic", dial_code: "+420", code: "CZ" },
                { name: "Denmark", dial_code: "+45", code: "DK" },
                { name: "Djibouti", dial_code: "+253", code: "DJ" },
                { name: "Dominica", dial_code: "+1-767", code: "DM" },
                { name: "Dominican Republic", dial_code: "+1-809", code: "DO" },
                { name: "Ecuador", dial_code: "+593", code: "EC" },
                { name: "Egypt", dial_code: "+20", code: "EG" },
                { name: "El Salvador", dial_code: "+503", code: "SV" },
                { name: "Equatorial Guinea", dial_code: "+240", code: "GQ" },
                { name: "Eritrea", dial_code: "+291", code: "ER" },
                { name: "Estonia", dial_code: "+372", code: "EE" },
                { name: "Eswatini", dial_code: "+268", code: "SZ" },
                { name: "Ethiopia", dial_code: "+251", code: "ET" },
                { name: "Fiji", dial_code: "+679", code: "FJ" },
                { name: "Finland", dial_code: "+358", code: "FI" },
                { name: "France", dial_code: "+33", code: "FR" },
                { name: "Gabon", dial_code: "+241", code: "GA" },
                { name: "Gambia", dial_code: "+220", code: "GM" },
                { name: "Georgia", dial_code: "+995", code: "GE" },
                { name: "Germany", dial_code: "+49", code: "DE" },
                { name: "Ghana", dial_code: "+233", code: "GH" },
                { name: "Greece", dial_code: "+30", code: "GR" },
                { name: "Grenada", dial_code: "+1-473", code: "GD" },
                { name: "Guatemala", dial_code: "+502", code: "GT" },
                { name: "Guinea", dial_code: "+224", code: "GN" },
                { name: "Guinea-Bissau", dial_code: "+245", code: "GW" },
                { name: "Guyana", dial_code: "+592", code: "GY" },
                { name: "Haiti", dial_code: "+509", code: "HT" },
                { name: "Honduras", dial_code: "+504", code: "HN" },
                { name: "Hungary", dial_code: "+36", code: "HU" },
                { name: "Iceland", dial_code: "+354", code: "IS" },
                { name: "India", dial_code: "+91", code: "IN" },
                { name: "Indonesia", dial_code: "+62", code: "ID" },
                { name: "Iran", dial_code: "+98", code: "IR" },
                { name: "Iraq", dial_code: "+964", code: "IQ" },
                { name: "Ireland", dial_code: "+353", code: "IE" },
                { name: "Israel", dial_code: "+972", code: "IL" },
                { name: "Italy", dial_code: "+39", code: "IT" },
                { name: "Jamaica", dial_code: "+1-876", code: "JM" },
                { name: "Japan", dial_code: "+81", code: "JP" },
                { name: "Jordan", dial_code: "+962", code: "JO" },
                { name: "Kazakhstan", dial_code: "+7", code: "KZ" },
                { name: "Kenya", dial_code: "+254", code: "KE" },
                { name: "Kuwait", dial_code: "+965", code: "KW" },
                { name: "Kyrgyzstan", dial_code: "+996", code: "KG" },
                { name: "Laos", dial_code: "+856", code: "LA" },
                { name: "Latvia", dial_code: "+371", code: "LV" },
                { name: "Lebanon", dial_code: "+961", code: "LB" },
                { name: "Lesotho", dial_code: "+266", code: "LS" },
                { name: "Liberia", dial_code: "+231", code: "LR" },
                { name: "Libya", dial_code: "+218", code: "LY" },
                { name: "Lithuania", dial_code: "+370", code: "LT" },
                { name: "Luxembourg", dial_code: "+352", code: "LU" },
                { name: "Madagascar", dial_code: "+261", code: "MG" },
                { name: "Malawi", dial_code: "+265", code: "MW" },
                { name: "Malaysia", dial_code: "+60", code: "MY" },
                { name: "Maldives", dial_code: "+960", code: "MV" },
                { name: "Mali", dial_code: "+223", code: "ML" },
                { name: "Malta", dial_code: "+356", code: "MT" },
                { name: "Mauritania", dial_code: "+222", code: "MR" },
                { name: "Mauritius", dial_code: "+230", code: "MU" },
                { name: "Mexico", dial_code: "+52", code: "MX" },
                { name: "Moldova", dial_code: "+373", code: "MD" },
                { name: "Monaco", dial_code: "+377", code: "MC" },
                { name: "Mongolia", dial_code: "+976", code: "MN" },
                { name: "Montenegro", dial_code: "+382", code: "ME" },
                { name: "Morocco", dial_code: "+212", code: "MA" },
                { name: "Mozambique", dial_code: "+258", code: "MZ" },
                { name: "Myanmar", dial_code: "+95", code: "MM" },
                { name: "Namibia", dial_code: "+264", code: "NA" },
                { name: "Nepal", dial_code: "+977", code: "NP" },
                { name: "Netherlands", dial_code: "+31", code: "NL" },
                { name: "New Zealand", dial_code: "+64", code: "NZ" },
                { name: "Nicaragua", dial_code: "+505", code: "NI" },
                { name: "Niger", dial_code: "+227", code: "NE" },
                { name: "Nigeria", dial_code: "+234", code: "NG" },
                { name: "North Korea", dial_code: "+850", code: "KP" },
                { name: "North Macedonia", dial_code: "+389", code: "MK" },
                { name: "Norway", dial_code: "+47", code: "NO" },
                { name: "Oman", dial_code: "+968", code: "OM" },
                { name: "Pakistan", dial_code: "+92", code: "PK" },
                { name: "Palestine", dial_code: "+970", code: "PS" },
                { name: "Panama", dial_code: "+507", code: "PA" },
                { name: "Papua New Guinea", dial_code: "+675", code: "PG" },
                { name: "Paraguay", dial_code: "+595", code: "PY" },
                { name: "Peru", dial_code: "+51", code: "PE" },
                { name: "Philippines", dial_code: "+63", code: "PH" },
                { name: "Poland", dial_code: "+48", code: "PL" },
                { name: "Portugal", dial_code: "+351", code: "PT" },
                { name: "Qatar", dial_code: "+974", code: "QA" },
                { name: "Romania", dial_code: "+40", code: "RO" },
                { name: "Russia", dial_code: "+7", code: "RU" },
                { name: "Rwanda", dial_code: "+250", code: "RW" },
                { name: "Saudi Arabia", dial_code: "+966", code: "SA" },
                { name: "Senegal", dial_code: "+221", code: "SN" },
                { name: "Serbia", dial_code: "+381", code: "RS" },
                { name: "Seychelles", dial_code: "+248", code: "SC" },
                { name: "Sierra Leone", dial_code: "+232", code: "SL" },
                { name: "Singapore", dial_code: "+65", code: "SG" },
                { name: "Slovakia", dial_code: "+421", code: "SK" },
                { name: "Slovenia", dial_code: "+386", code: "SI" },
                { name: "Somalia", dial_code: "+252", code: "SO" },
                { name: "South Africa", dial_code: "+27", code: "ZA" },
                { name: "South Korea", dial_code: "+82", code: "KR" },
                { name: "South Sudan", dial_code: "+211", code: "SS" },
                { name: "Spain", dial_code: "+34", code: "ES" },
                { name: "Sri Lanka", dial_code: "+94", code: "LK" },
                { name: "Sudan", dial_code: "+249", code: "SD" },
                { name: "Suriname", dial_code: "+597", code: "SR" },
                { name: "Sweden", dial_code: "+46", code: "SE" },
                { name: "Switzerland", dial_code: "+41", code: "CH" },
                { name: "Syria", dial_code: "+963", code: "SY" },
                { name: "Taiwan", dial_code: "+886", code: "TW" },
                { name: "Tajikistan", dial_code: "+992", code: "TJ" },
                { name: "Tanzania", dial_code: "+255", code: "TZ" },
                { name: "Thailand", dial_code: "+66", code: "TH" },
                { name: "Togo", dial_code: "+228", code: "TG" },
                { name: "Trinidad and Tobago", dial_code: "+1-868", code: "TT" },
                { name: "Tunisia", dial_code: "+216", code: "TN" },
                { name: "Turkey", dial_code: "+90", code: "TR" },
                { name: "Turkmenistan", dial_code: "+993", code: "TM" },
                { name: "Uganda", dial_code: "+256", code: "UG" },
                { name: "Ukraine", dial_code: "+380", code: "UA" },
                { name: "United Arab Emirates", dial_code: "+971", code: "AE" },
                { name: "United Kingdom", dial_code: "+44", code: "GB" },
                { name: "United States", dial_code: "+1", code: "US" },
                { name: "Uruguay", dial_code: "+598", code: "UY" },
                { name: "Uzbekistan", dial_code: "+998", code: "UZ" },
                { name: "Vanuatu", dial_code: "+678", code: "VU" },
                { name: "Vatican City", dial_code: "+379", code: "VA" },
                { name: "Venezuela", dial_code: "+58", code: "VE" },
                { name: "Vietnam", dial_code: "+84", code: "VN" },
                { name: "Yemen", dial_code: "+967", code: "YE" },
                { name: "Zambia", dial_code: "+260", code: "ZM" },
                { name: "Zimbabwe", dial_code: "+263", code: "ZW" }
            ];
            const navigate = useNavigate();
            const [loading, setLoading] = useState(false);
            const [submitted, setSubmitted] = useState(false);
            const [formData, setFormData] = useState({
                name: "",
                countryCode: "+1",
                phone: "",
                email: "",
                arrival: "",
                departure: "",
                adults: "",
                children: "",
                pageUrl: window.location.href,
                honeypot: "",
            });
        
            const [errors, setErrors] = useState({});
        
            const validate = () => {
                let newErrors = {};
        
                if (!formData.name.trim()) newErrors.name = "Name is required.";
                if (!formData.phone.trim()) {
                    newErrors.phone = "Phone is required.";
                } else if (!/^[0-9]{7,15}$/.test(formData.phone)) {
                    newErrors.phone = "Enter a valid phone number.";
                }
                if (!formData.email.trim()) newErrors.email = "Email is required.";
                else if (!/\S+@\S+\.\S+/.test(formData.email))
                    newErrors.email = "Enter a valid email.";
                if (!formData.arrival) newErrors.arrival = "Arrival date is required.";
                if (!formData.departure) newErrors.departure = "Departure date is required.";
                if (formData.adults < 1) newErrors.adults = "At least 1 adult required.";
        
                setErrors(newErrors);
                return Object.keys(newErrors).length === 0;
            };
        
            const handleSubmit = (e) => {
                e.preventDefault();
                if (formData.honeypot) {
                    return;
                }
                if (validate()) {
                    setLoading(true);
                    emailjs
                        .send(
                            'service_7a7oaql',
                            'template_n7du4w7',
                            formData,
                            'Qb8VI-rZV7Kpa7BFC'
                        )
                        .then(() => {
                            setSubmitted(true);
                            setFormData({
                                name: "",
                                countryCode: "+1",
                                phone: "",
                                email: "",
                                arrival: "",
                                departure: "",
                                adults: "",
                                children: "",
                                pageUrl: window.location.href,
                                honeypot: "",
                            });
                            setErrors({});
                        })
                        .catch(() => {
        
                            alert("Something went wrong. Please try again.");
                        })
                        .finally(() => {
                            setLoading(false);
                            navigate("/ThankYou");
                        });
                }
            };
        
            const handleChange = (e) => {
                setFormData({ ...formData, [e.target.name]: e.target.value });
            };


  return (
    <div>
            <Helmet>
                <title> 4-Day Wildlife Adventure Tanzania</title>
                <meta
                    name="description"
                    content="4-day safari exploring Tarangire's elephant herds and the vast Serengeti plains, home to the great wildebeest migration and abundant big cats."
                />
                <meta name="keywords" content="Tarangire Safari, Serengeti National Park, Wildebeest Migration, Tanzania Safari, Big Cats, Elephant Herds Tanzania" />
                <link rel="canonical" href="https://www.kamerazofafrika.com/tarangire_serengeti_safari" />
            </Helmet>


            {/* Hero Section */}
            <div
                className="text-white d-flex align-items-center"
                style={{
                    backgroundImage: `url(${backgroundUrl})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    height: "80vh",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        zIndex: 1,
                    }}
                ></div>
                <div className="container position-relative" style={{ zIndex: 2 }}>
                    <div className="row">
                        <h1 className="fw-bold text-center text-white">
                            4 Days Tanzania Safari
                        </h1>
                        
                        <h5 className="fw-bold text-center text-white mt-4">Starting From  <span className='bounce' >$1800 USD/PAX </span></h5>
                        
                    </div>
                </div>
            </div>

            <div ref={cardsRef}>
                {isInView ? (
                    <div
                        style={{
                            position: "relative",
                            zIndex: 100,
                            backgroundImage: "var(--bg-image)",
                            backgroundAttachment: "fixed",
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                        }}
                    >
                        <div className="container position-relative">
                            <div className="row g-3">
                                {/* Sticky Dropdown Column */}
                                <div className="col-12 col-md-6 col-lg-3 mb-5 mb-md-0">
                                    <div>
                                        <div
                                            className="dropdown w-100 p-1 text-center mb-2 mb-md-0"
                                            style={{ backgroundColor: "#198754", borderRadius: "12px", marginTop: '-40px' }}
                                        >
                                            <button
                                                className="btn btn-success dropdown-toggle fw-bold w-100"
                                                type="button"
                                                id="sectionDropdown"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                                style={{ borderRadius: "12px" }}
                                            >
                                                Jump to Section
                                            </button>
                                            <ul className="dropdown-menu w-100" aria-labelledby="sectionDropdown">
                                                <li><button className="dropdown-item" onClick={() => document.getElementById("Overview")?.scrollIntoView({ behavior: "smooth" })}>Overview</button></li>
                                                <li><button className="dropdown-item" onClick={() => document.getElementById("Highlights")?.scrollIntoView({ behavior: "smooth" })}>Highlights</button></li>
                                                <li><button className="dropdown-item" onClick={() => document.getElementById("Inclusions")?.scrollIntoView({ behavior: "smooth" })}>Inclusions</button></li>
                                                <li><button className="dropdown-item" onClick={() => document.getElementById("Itinerary")?.scrollIntoView({ behavior: "smooth" })}>Itinerary</button></li>
                                                <li><button className="dropdown-item" onClick={() => document.getElementById("Testimonials")?.scrollIntoView({ behavior: "smooth" })}>Testimonials</button></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                {/* Duration Card */}
                                <div className="col-12 col-md-6 col-lg-3">
                                    <div className="bg-white shadow-sm p-3 py-5 border border-success border-1 h-100 d-flex align-items-center" style={{ borderRadius: "20px", marginTop: '-60px' }}>
                                        <div className="me-3 fs-3 text-success">
                                            <i className="bi bi-clock-fill"></i>
                                        </div>
                                        <div>
                                            <h6 className="fw-bold mb-1">Duration</h6>
                                            <a href="#" className="text-success text-uppercase small fw-bold text-decoration-none">4 Days / 3 Nights</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                    <div className="bg-white shadow-sm p-3 py-5 border border-success border-1 h-100 d-flex align-items-center" style={{ borderRadius: "20px", marginTop: '-60px' }}>
                                        <div className="me-3 fs-3 text-success">
                                            <i className="bi bi-tag"></i>
                                        </div>
                                        <div>
                                            <h6 className="fw-bold mb-1">Price</h6>
                                            <a href="#" className="text-success text-uppercase small fw-bold text-decoration-none">Starting From $1800</a>
                                        </div>
                                    </div>
                                </div>

                                

                            </div>
                        </div>
                    </div>
                ) : (
                    <div>
                        <div
                            style={{
                                position: "relative",
                                zIndex: 100,
                                backgroundImage: "var(--bg-image)",
                                backgroundAttachment: "fixed",
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                            }}
                        >
                            <div className="container position-relative">
                                <div className="row g-3">
                                    {/* Sticky Dropdown Column */}
                                    <div className="col-12 col-md-6 col-lg-3 mb-5 mb-md-0">
                                        <div>
                                            <div
                                                className="dropdown w-100 p-1 text-center mb-2 mb-md-0"
                                                style={{ backgroundColor: "#198754", borderRadius: "12px", marginTop: '-40px' }}
                                            >
                                                <button
                                                    className="btn btn-success dropdown-toggle fw-bold w-100"
                                                    type="button"
                                                    id="sectionDropdown"
                                                    data-bs-toggle="dropdown"
                                                    aria-expanded="false"
                                                    style={{ borderRadius: "12px" }}
                                                >
                                                    Jump to Section
                                                </button>
                                                <ul className="dropdown-menu w-100" aria-labelledby="sectionDropdown">
                                                    <li><button className="dropdown-item" onClick={() => document.getElementById("Overview")?.scrollIntoView({ behavior: "smooth" })}>Overview</button></li>
                                                    <li><button className="dropdown-item" onClick={() => document.getElementById("Highlights")?.scrollIntoView({ behavior: "smooth" })}>Highlights</button></li>
                                                    <li><button className="dropdown-item" onClick={() => document.getElementById("Inclusions")?.scrollIntoView({ behavior: "smooth" })}>Inclusions</button></li>
                                                    <li><button className="dropdown-item" onClick={() => document.getElementById("Itinerary")?.scrollIntoView({ behavior: "smooth" })}>Itinerary</button></li>
                                                    <li><button className="dropdown-item" onClick={() => document.getElementById("Testimonials")?.scrollIntoView({ behavior: "smooth" })}>Testimonials</button></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Duration Card */}
                                    <div className="col-12 col-md-6 col-lg-3">
                                        <div className="bg-white shadow-sm p-3 py-5 border border-success border-1 h-100 d-flex align-items-center" style={{ borderRadius: "20px", marginTop: '-60px' }}>
                                            <div className="me-3 fs-3 text-success">
                                                <i className="bi bi-clock-fill"></i>
                                            </div>
                                            <div>
                                                <h6 className="fw-bold mb-1">Duration</h6>
                                                <a href="#" className="text-success text-uppercase small fw-bold text-decoration-none">4 Days / 3 Nights</a>
                                            </div>
                                        </div>
                                    </div>

                                   

                                </div>
                            </div>
                        </div>
                        <div
                            style={{
                                position: "fixed",
                                top: '50px',
                                left: '20%',
                                zIndex: 1000,
                            }}
                        >
                            <div className="container position-relative">
                                <div className="row g-3">
                                    {/* Sticky Dropdown Column */}
                                    <div className="col-12 col-md-6 col-lg-3">
                                        <div>
                                            <div
                                                className="dropdown w-100 p-1 text-center sticky-dropdown"
                                                style={{ backgroundColor: "#198754", borderRadius: "12px", marginTop: '-40px', minWidth: "200px", width: '200px' }}
                                            >
                                                <button
                                                    className="btn btn-success dropdown-toggle fw-bold w-100"
                                                    type="button"
                                                    id="sectionDropdown"
                                                    data-bs-toggle="dropdown"
                                                    aria-expanded="false"
                                                    style={{ borderRadius: "12px" }}
                                                >
                                                    Jump to Section
                                                </button>
                                                <ul className="dropdown-menu w-100" aria-labelledby="sectionDropdown">
                                                    <li><button className="dropdown-item" onClick={() => document.getElementById("Overview")?.scrollIntoView({ behavior: "smooth" })}>Overview</button></li>
                                                    <li><button className="dropdown-item" onClick={() => document.getElementById("Highlights")?.scrollIntoView({ behavior: "smooth" })}>Highlights</button></li>
                                                    <li><button className="dropdown-item" onClick={() => document.getElementById("Inclusions")?.scrollIntoView({ behavior: "smooth" })}>Inclusions</button></li>
                                                    <li><button className="dropdown-item" onClick={() => document.getElementById("Itinerary")?.scrollIntoView({ behavior: "smooth" })}>Itinerary</button></li>
                                                    <li><button className="dropdown-item" onClick={() => document.getElementById("Testimonials")?.scrollIntoView({ behavior: "smooth" })}>Testimonials</button></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            <div style={{
                backgroundImage: "var(--bg-image)",
                backgroundAttachment: "fixed",
                backgroundSize: "cover",
                backgroundPosition: "center",
            }}>
                <div className="container py-5">
                    <div className="row g-4">
                        {/* Left Content */}
                        <div className="col-lg-8">
                            {/* 
                            <Carousel interval={null}>
                                {slides.map((slide, i) => (
                                    <Carousel.Item key={i}>
                                        <div className="row g-2">
                                            {slide.map((img, j) => (
                                                <div
                                                    key={j}
                                                    className={`col-${12 / itemsPerSlide}`}
                                                    onClick={() => handleShow(i * itemsPerSlide + j)}
                                                    style={{ cursor: "pointer" }}
                                                >
                                                    <img loading="lazy"
                                                        src={img}
                                                        alt=""
                                                        className="img-fluid rounded"
                                                        style={{ width: "100%", height: "auto" }}
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    </Carousel.Item>
                                ))}
                            </Carousel>
                            */}

                            {/* Title and CTA */}
                            <div className="d-flex justify-content-between align-items-center mb-2 mt-5">
                                <h2 className="fw-bold text-dark mb-0">4 Days Tanzania Safari</h2>
                            </div>

                            {/* Location */}
                            <p className=" mb-5">
                                <i className="bi bi-geo-alt-fill me-2 text-primary"></i>
                                Start: Tarangire | End: Arusha
                            </p>

                            {/* Overview */}
                            <h5 className="fw-bold text-dark" id='Overview'>
                                <i className="bi bi-journal-text me-2 text-primary"></i> Overview
                            </h5>
                            <p className="">
                                Embark on an unforgettable 4-day safari adventure through two of Tanzania's most iconic national parks. This journey takes you from the elephant-rich landscapes of Tarangire to the vast, wildlife-teeming plains of the Serengeti, offering an incredible diversity of wildlife viewing experiences and breathtaking African scenery.
                            </p>
                            <p className="">
                                Experience the best of Northern Tanzania's wildlife in this comprehensive safari that combines the intimate wildlife encounters of Tarangire with the epic scale and drama of the Serengeti ecosystem. From massive elephant herds to the great wildebeest migration and abundant big cats, this safari delivers unforgettable wildlife moments and photographic opportunities.
                            </p>

                            {/* Highlights Section */}
                            <div className="mt-5">
                                <h5 className="fw-bold text-dark" id='Highlights'>
                                    <i className="bi bi-stars me-2 text-primary"></i> Highlights
                                </h5>
                                <div className="row">
                                    <div className="col-md-6 mb-4">
                                        <div className="border-5 shadow-lg h-100">
                                            <div className="card-body">
                                                <h6 className="card-title fw-bold text-primary">Serengeti National Park</h6>
                                                <p className="card-text ">
                                                    Go on a Serengeti Safari and experience a soul-stirring feeling of space. Serengeti comes from the Masai word 'Siringit' meaning 'the place where the land runs on forever' and refers to the flat grassy plains which make up about a third of the park. It is these grasslands and savannahs that ensure that the area is jam-packed full of game.
                                                </p>
                                                <p className="card-text ">
                                                    There are animals here at any time of year, but from October to May, the area teems with life, including wildebeest, zebra, impala, warthogs, topi, gazelles and hyena. Lion, leopard, cheetah, and caracal can be more easily spotted in the Kopjes, granite inselbergs scattered across the landscape.
                                                </p>
                                                <p className="card-text ">
                                                    The Serengeti is well known for the wildebeest migration when every year two million animals move clockwise around this 14,763 sq km ecosystem in search of grazing and water. The predators follow the wildebeest and zebra closely and a Serengeti Safari is an ideal opportunity to view lions and other big cats.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 mb-4">
                                        <div className="border-5 shadow-lg h-100">
                                            <div className="card-body">
                                                <h6 className="card-title fw-bold text-primary">Tarangire National Park</h6>
                                                <p className="card-text ">
                                                    Tarangire is a long, thin park covering 1360 sq km running along the line of the Tarangire River. Although it is relatively small, Tarangire is easy to access and has some of the greatest concentrations of game in Tanzania – second only to the Ngorongoro Crater – and there are not nearly as many tourists.
                                                </p>
                                                <p className="card-text ">
                                                    Go on a Tarangire Safari and experience the unrivalled landscape of open plains dotted with thousands of baobabs. Game viewing in Tarangire is largely affected by the presence of water, and during the dry season, many animals congregate here in search of it. As the land dries and the smaller rivers stop flowing, the herds head south towards the permanent water in the Tarangire River and its surrounding swamps.
                                                </p>
                                                <p className="card-text ">
                                                    Although the elephants in this area suffered badly from poaching, they have recovered well. On a Tarangire safari, you are virtually guaranteed to see large herds of elephants, including lots of cute babies. As a holiday destination, Tarangire is a lot less busy than other parks in the north of Tanzania. Going on a safari here offers you a chance to savor a real slice of Africa's wilderness and solitude.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="mt-5">
                                <hr className="w-50 mx-auto border-2 border-primary my-5" />
                                <h5 className="fw-bold mb-4" id='Inclusions'>
                                    <i className="bi bi-check2-circle me-2 text-primary"></i>
                                    Included & Excluded
                                </h5>
                                <div className="row">
                                    {/* Included */}
                                    <div className="col-md-6 mb-3">
                                        <h6 className="fw-bold">Included:</h6>
                                        <ul className="list-unstyled ">
                                            <li className="d-flex align-items-center mb-2">
                                                <i className="bi bi-check fs-3 text-success me-2"></i>
                                                All national park fees and conservation fees
                                            </li>
                                            <li className="d-flex align-items-center mb-2">
                                                <i className="bi bi-check fs-3 text-success me-2"></i>
                                                Professional English-speaking safari guide
                                            </li>
                                            <li className="d-flex align-items-center mb-2">
                                                <i className="bi bi-check fs-3 text-success me-2"></i>
                                                4x4 safari vehicle with pop-up roof
                                            </li>
                                            <li className="d-flex align-items-center mb-2">
                                                <i className="bi bi-check fs-3 text-success me-2"></i>
                                                All game drives as per itinerary
                                            </li>
                                            <li className="d-flex align-items-center mb-2">
                                                <i className="bi bi-check fs-3 text-success me-2"></i>
                                                3 nights accommodation (lodge/campsite)
                                            </li>
                                            <li className="d-flex align-items-center mb-2">
                                                <i className="bi bi-check fs-3 text-success me-2"></i>
                                                All meals during the safari
                                            </li>
                                            <li className="d-flex align-items-center mb-2">
                                                <i className="bi bi-check fs-3 text-success me-2"></i>
                                                Picnic lunches during game drives
                                            </li>
                                            <li className="d-flex align-items-center mb-2">
                                                <i className="bi bi-check fs-3 text-success me-2"></i>
                                                Drinking water in the vehicle
                                            </li>
                                            <li className="d-flex align-items-center mb-2">
                                                <i className="bi bi-check fs-3 text-success me-2"></i>
                                                All government taxes
                                            </li>
                                            <li className="d-flex align-items-center mb-2">
                                                <i className="bi bi-check fs-3 text-success me-2"></i>
                                                Ngorongoro crater service fees
                                            </li>
                                        </ul>
                                    </div>

                                    {/* Excluded */}
                                    <div className="col-md-6 mb-3">
                                        <h6 className="fw-bold">Excluded:</h6>
                                        <ul className="list-unstyled ">
                                            <li className="d-flex align-items-center mb-2">
                                                <i className="bi bi-x fs-3 text-danger me-2"></i>
                                                International and domestic flights
                                            </li>
                                            <li className="d-flex align-items-center mb-2">
                                                <i className="bi bi-x fs-3 text-danger me-2"></i>
                                                Tanzania visa fees
                                            </li>
                                            <li className="d-flex align-items-center mb-2">
                                                <i className="bi bi-x fs-3 text-danger me-2"></i>
                                                Travel and medical insurance
                                            </li>
                                            <li className="d-flex align-items-center mb-2">
                                                <i className="bi bi-x fs-3 text-danger me-2"></i>
                                                Tips for guide and camp staff
                                            </li>
                                            <li className="d-flex align-items-center mb-2">
                                                <i className="bi bi-x fs-3 text-danger me-2"></i>
                                                Alcoholic and soft drinks
                                            </li>
                                            <li className="d-flex align-items-center mb-2">
                                                <i className="bi bi-x fs-3 text-danger me-2"></i>
                                                Personal expenses and souvenirs
                                            </li>
                                            <li className="d-flex align-items-center mb-2">
                                                <i className="bi bi-x fs-3 text-danger me-2"></i>
                                                Accommodation before/after safari
                                            </li>
                                            <li className="d-flex align-items-center mb-2">
                                                <i className="bi bi-x fs-3 text-danger me-2"></i>
                                                Optional activities not mentioned
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <hr className="w-50 mx-auto border-2 border-primary my-3" />
                            </div>

                            {/* Itinerary Section */}
                            <div className="mt-5">
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h5 className="fw-bold text-dark mb-0" id='Itinerary'>
                                        <i className="bi bi-car-front me-3 text-primary"></i>
                                        Itinerary
                                    </h5>
                                    <span className="fw-bold text-dark">
                                        4 Days <small className="">/ 3 Nights</small>
                                    </span>
                                </div>

                                <div className="accordion" id="itineraryAccordion">
                                    {/* Day 1 */}
                                    <div className="accordion-item border mb-4" style={{ borderRadius: "20px", overflow: "hidden" }}>
                                        <h2 className="accordion-header" id="day1">
                                            <button className="accordion-button fw-bold py-4" type="button" data-bs-toggle="collapse" data-bs-target="#collapseDay1" aria-expanded="true" aria-controls="collapseDay1">
                                                Day 1: Tarangire National Park
                                            </button>
                                        </h2>
                                        <div id="collapseDay1" className="accordion-collapse collapse show" aria-labelledby="day1" data-bs-parent="#itineraryAccordion">
                                            <div className="accordion-body ">
                                                After breakfast, drive to Tarangire National Park with picnic lunches for a full day game viewing. Explore this magnificent park known for its massive elephant herds, ancient baobab trees, and diverse wildlife. The Tarangire River acts as a vital water source, attracting thousands of animals during the dry season. Witness large herds of elephants, buffalo, zebra, wildebeest, and various antelope species. The park is also excellent for birdwatching with over 500 species recorded.
                                                <p className="mt-2"><strong>Dinner and overnight at the Lodge or at Public Campsite.</strong></p>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Day 2 */}
                                    <div className="accordion-item border mb-4" style={{ borderRadius: "20px", overflow: "hidden" }}>
                                        <h2 className="accordion-header" id="day2">
                                            <button className="accordion-button collapsed fw-bold py-4" type="button" data-bs-toggle="collapse" data-bs-target="#collapseDay2" aria-expanded="false" aria-controls="collapseDay2">
                                                Day 2: Tarangire to Serengeti National Park
                                            </button>
                                        </h2>
                                        <div id="collapseDay2" className="accordion-collapse collapse" aria-labelledby="day2" data-bs-parent="#itineraryAccordion">
                                            <div className="accordion-body ">
                                                After breakfast, drive to Serengeti National Park with picnic lunch. Experience the breathtaking transition from Tarangire's baobab-dotted landscape to the endless plains of the Serengeti. Enjoy afternoon game viewing in this world-renowned ecosystem, home to the great wildebeest migration and abundant predators. The Serengeti offers incredible wildlife viewing opportunities with chances to spot lions, leopards, cheetahs, and large herds of herbivores.
                                                <p className="mt-2"><strong>Dinner and overnight at the Lodge or at the public campsite.</strong></p>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Day 3 */}
                                    <div className="accordion-item border mb-4" style={{ borderRadius: "20px", overflow: "hidden" }}>
                                        <h2 className="accordion-header" id="day3">
                                            <button className="accordion-button collapsed fw-bold py-4" type="button" data-bs-toggle="collapse" data-bs-target="#collapseDay3" aria-expanded="false" aria-controls="collapseDay3">
                                                Day 3: Serengeti to Ngorongoro Area
                                            </button>
                                        </h2>
                                        <div id="collapseDay3" className="accordion-collapse collapse" aria-labelledby="day3" data-bs-parent="#itineraryAccordion">
                                            <div className="accordion-body ">
                                                Enjoy your last game viewing in the Serengeti National Park with picnic lunch. Take in the final moments of this spectacular ecosystem, searching for wildlife you may have missed and enjoying the vast African landscapes. The morning game drive offers excellent opportunities for photography and wildlife observation. After lunch, begin your journey toward the Ngorongoro Conservation Area, driving through scenic landscapes and potentially spotting wildlife along the way.
                                                <p className="mt-2"><strong>Afternoon drive to the Ngorongoro area. Dinner and overnight at the Lodge or at the public campsite.</strong></p>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Day 4 */}
                                    <div className="accordion-item border" style={{ borderRadius: "20px", overflow: "hidden" }}>
                                        <h2 className="accordion-header" id="day4">
                                            <button className="accordion-button collapsed fw-bold py-4" type="button" data-bs-toggle="collapse" data-bs-target="#collapseDay4" aria-expanded="false" aria-controls="collapseDay4">
                                                Day 4: Ngorongoro Crater - Return to Arusha
                                            </button>
                                        </h2>
                                        <div id="collapseDay4" className="accordion-collapse collapse" aria-labelledby="day4" data-bs-parent="#itineraryAccordion">
                                            <div className="accordion-body ">
                                                After breakfast, descend down into the crater floor with picnic lunch for game viewing. Experience the breathtaking Ngorongoro Crater, often called the 'Eighth Wonder of the World'. This UNESCO World Heritage Site is the world's largest intact volcanic caldera, hosting approximately 25,000 large animals. The crater offers excellent game viewing with high chances of spotting the Big Five, including the endangered black rhino. Explore the diverse habitats within the crater, from grasslands to forested areas and the central soda lake.
                                                <p className="mt-2"><strong>Late afternoon drive back to Arusha for drop off. End of Services.</strong></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Testimonials Section */}
                            <div className="mt-5">
                                <div className="container">
                                    <div className="text-center">
                                        <h6 className="section-title text-center text-primary px-3" id='Testimonials'>Testimonials</h6>
                                        <h1 className="mb-2">Our Clients Say!</h1>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-center">
                                        <TesCarousel />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Right Sidebar Form */}
                        <div className="col-lg-4" id='bookingForm'>
                            <div className='sticky-desktop'>
                                <div
                                    className="shadow pb-4 bg-white mt-5"
                                    style={{ borderRadius: "15px" }}
                                >
                                    <div
                                        className="bg-primary text-center text-white p-3 mb-5 fw-bold"
                                        style={{ borderTopLeftRadius: "20px", borderTopRightRadius: "20px" }}
                                    >
                                        Book This Safari
                                    </div>
                                    <form className="px-4" onSubmit={handleSubmit} noValidate>
                                        <div className="mb-3">
                                            <input
                                                type="text"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleChange}
                                                className="form-control"
                                                style={{ borderRadius: "10px" }}
                                                placeholder="Your Name"
                                            />
                                            {errors.name && <small className="text-danger">{errors.name}</small>}
                                        </div>
                                        <div className="mb-3">
                                            <select
                                                name="countryCode"
                                                value={formData.countryCode}
                                                onChange={handleChange}
                                                className="form-select me-2"
                                                style={{ borderRadius: "10px", maxWidth: "150px" }}
                                            >
                                                {countryCodes.map((c) => (
                                                    <option key={c.code} value={c.dial_code}>
                                                        {c.name} ({c.dial_code})
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className="mb-3">
                                            <input
                                                type="text"
                                                name="phone"
                                                value={formData.phone}
                                                onChange={handleChange}
                                                style={{ borderRadius: "10px" }}
                                                className="form-control"
                                                placeholder="Your Phone"
                                            />
                                            {errors.phone && (
                                                <small className="text-danger">{errors.phone}</small>
                                            )}
                                        </div>
                                        <div className="mb-3">
                                            <input
                                                type="email"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                style={{ borderRadius: "10px" }}
                                                className="form-control"
                                                placeholder="Your Email"
                                            />
                                            {errors.email && (
                                                <small className="text-danger">{errors.email}</small>
                                            )}
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="arrivalDate" className=''>Arrival Date</label>

                                            <input
                                                type="date"
                                                name="arrival"
                                                value={formData.arrival}
                                                placeholder="Arrival Date"
                                                onChange={handleChange}
                                                style={{ borderRadius: "10px" }}
                                                className="form-control"
                                            />
                                            {errors.arrival && (
                                                <small className="text-danger">{errors.arrival}</small>
                                            )}

                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="departureDate" className=''>Departure Date</label>
                                            <input
                                                type="date"
                                                name="departure"
                                                value={formData.departure}
                                                onChange={handleChange}
                                                style={{ borderRadius: "10px" }}
                                                className="form-control"
                                            />
                                            {errors.departure && (
                                                <small className="text-danger">{errors.departure}</small>
                                            )}

                                        </div>
                                        <div className="mb-3">
                                            <input
                                                type="number"
                                                name="adults"
                                                value={formData.adults}
                                                onChange={handleChange}
                                                style={{ borderRadius: "10px" }}
                                                className="form-control"
                                                placeholder="Adults"
                                            />
                                            {errors.adults && (
                                                <small className="text-danger">{errors.adults}</small>
                                            )}
                                        </div>
                                        <div className="mb-3">
                                            <input
                                                type="number"
                                                name="children"
                                                value={formData.children}
                                                onChange={handleChange}
                                                style={{ borderRadius: "10px" }}
                                                className="form-control"
                                                placeholder="Children"
                                            />
                                        </div>
                                        <div style={{ display: "none" }}>
                                            <input
                                                type="text"
                                                name="honeypot"
                                                value={formData.honeypot}
                                                onChange={handleChange}
                                                tabIndex="-1"
                                                autoComplete="off"
                                            />
                                        </div>
                                        <button
                                            type="submit"
                                            className="btn btn-primary w-100 fw-bold text-white mt-4"
                                            style={{ borderRadius: "20px" }}
                                            disabled={loading}
                                        >
                                            {loading ? (
                                                <>
                                                    <i className="bi bi-arrow-repeat me-2 spin" />
                                                    Sending...
                                                </>
                                            ) : (
                                                "Book Now"
                                            )}
                                        </button>
                                        {submitted && (
                                            <div className="alert alert-success mt-4" style={{ borderRadius: '20px' }}>Your message has been sent!</div>
                                        )}
                                    </form>
                                </div>
                            </div>
                        </div>

                        {/* Modal with Carousel */}
                        <Modal show={showModal} onHide={() => setShowModal(false)} size="xl" centered>
                            <Modal.Body className="p-0 bg-dark position-relative">
                                <Carousel activeIndex={activeIndex} onSelect={(selectedIndex) => setActiveIndex(selectedIndex)} interval={null}>
                                    {images.map((img, i) => (
                                        <Carousel.Item key={i}>
                                            <img loading="lazy" src={img} alt="" className="d-block w-100" style={{ maxHeight: "90vh", objectFit: "contain" }} />
                                        </Carousel.Item>
                                    ))}
                                </Carousel>
                                <button className="btn btn-light position-absolute top-0 end-0 m-2" onClick={() => setShowModal(false)}>✕</button>
                            </Modal.Body>
                        </Modal>
                    </div>
                </div>
            </div>
        </div>
    );
}